import { SelectList } from '@acies/core';
import { ModelPosition, TextPosition } from '@acies/domain';
import PositionItemRenderer from './position-item-renderer';

/**
 * The PositionsList is responsible for rendering an Array of Position items.
 *
 * The data property accepts this Array of items and the ItemRenderer property defines the class that is responsible for displaying the item visually.
 */
export class PositionsList extends SelectList<ModelPosition | TextPosition> {
	public constructor() {
		super();
		this.width = 'fill';
		this.height = 'fill';
		this.paddingHorizontal = 0;
		// give space for focus rings inside list.
		this.paddingVertical = 2;
		this.paddingHorizontal = 2;
		this.gapVertical = 8;
		this.hideScrollbars = true;
		this.ItemRenderer = PositionItemRenderer;
	}
}
customElements.define('ac-positions-list', PositionsList);
